import React, { useContext, useEffect } from 'react';
import Divider from '@fuww/library/src/Login/Divider';
import withApollo from '../lib/apollo';
import useRedirectOnSignupSuccess from '../lib/useRedirectOnSignupSuccess';
import SignupComponent from '../components/LoginSignup/Signup';
import SignupForm from '../components/LoginSignup/SignupForm';
import { UserContext } from '../components/UserProvider';
import { useSiteContext } from '../components/SiteContext';
import { Router } from '../routes.mjs';
import SignupWithProviderForm
from '../components/LoginSignup/SignupWithProviderForm';

export const Signup = () => {
  const [signupSuccess, setSignupSuccess] = useRedirectOnSignupSuccess();
  const { user } = useContext(UserContext);
  const { dashboard } = useSiteContext();

  useEffect(() => {
    if (user) Router.replaceRoute('index');
  }, [user]);

  return (
    <SignupComponent
      signupSuccess={signupSuccess}
      showBreadcrumbs={!dashboard}
    >
      <SignupForm
        setSignupSuccess={setSignupSuccess}
      />
      <Divider dividerText="OR" />
      <SignupWithProviderForm
        provider="google"
        setSignupSuccess={setSignupSuccess}
      />
      <SignupWithProviderForm
        provider="linkedin"
        setLoginSuccess={setSignupSuccess}
      />
    </SignupComponent>
  );
};

export default withApollo(Signup);
